

<template>
  <estilizacao-global />
  <div class="modal-popup"></div>
  <PToast :breakpoints="{'500px': {width: '100%', right: '0', left: '0'}}"/>
  <router-view></router-view>
</template>

<script>
import { defineComponent } from 'vue';
import EVENTS from "@/shared/events/events";


export default defineComponent({
  mounted(){
    this.$store.commit('initialiseStore');
    this.mitt.on(EVENTS.desligaModalSistema, () => {
      this.modalDisplay = 'none';
    });

    this.mitt.on(EVENTS.ligaModalSistema, () => {
      this.modalDisplay = 'block';
    });

  },
  data(){
    return{
      modalDisplay: 'none',
    }
  }
})
</script>


<style>

@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@100;500&display=swap');


.modal-popup{
  height: 1000vh;
  width: 1000vw;
  position: fixed;
  z-index: 3;
  background-color: rgba(85, 85, 85, 0.396);
  display: v-bind('modalDisplay');
}

.v-popper__popper{
  z-index: 100 !important;
}

:root{
  --amarelo-principal: #fcb316;
  --texto-marrom: #4f2c19;
}

body{
  background-color: #F3F3F3;
  min-height: 100vh;
  height: fit-content;
  margin: 0px;
  padding: 0px;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif, 'Montserrat', sans-serif; ;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100vh;
}
/* classe para asterisco de campo obrigatorio */
.asterisco-obrigatorio{
  color: red;
  /* margin-left: 5px; */
}
/* parte para estilizar os checkobx do projeto */
/* remover em um segundo momento */

/* .p-checkbox .p-checkbox-box.p-highlight{
  border-color:#D6D6D6 !important;
  background: #707070 !important;
}

.p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-highlight:hover{
    border-color:#D6D6D6 !important;
    background: #707070 !important;
} */

.g-form-conteudo .p-checkbox.p-checkbox-box.p-focus {
    box-shadow: transparent !important;
}
/* .g-form-conteudo .p-checkbox .p-highlight.p-checkbox-box.p-focus{
    border-color: #D6D6D6 !important;
    box-shadow: none;
} */
/* .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-focus{
    border-color: #D6D6D6 !important;
    box-shadow: none !important;
} */

/* .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box:hover{
  border-color: #707070 !important;
} */

/*Ajustando dropdowns */
.p-dropdown-items-wrapper .p-dropdown-items {
  max-height: 200px !important;
}

.invisivel{
  visibility: hidden;
}

</style>
